import { VipRules } from '@quickService/ActivitiesVipGetAllVipRules';

export type RuleItem = VipRules[0];

export enum RuleType {
  /** 免费版 */
  free = 'free',
  /** 基础版 */
  basic = 'basic',
  /** 高级版 */
  deluxe = 'deluxe',
  /** 旗舰 */
  ultimate = 'ultimate',
}

export interface CardData {
  name: string;
  price: string;
  realPrice: string;
  discount?: string;
  key: RuleType | string;
  features: {
    title: string;
    key: string;
    num?: number;
    config?: boolean;
  }[];
}

/** 获取具体资源的人数，比如主持人、嘉宾人数 */
export const getResourceSumNum = (resource: RuleItem['rule']['guest_resource']) => {
  const sum = resource?.reduce((sum, item) => sum + Number(item.value), 0);
  return sum;
};

/** 获取嘉宾数量 */
export const getGuestResourceNum = (ruleItem: RuleItem) => {
  const guestResource = ruleItem.rule.guest_resource;
  return getResourceSumNum(guestResource);
};

/** 获取主持人数量 */
export const getHostResourceNum = (ruleItem: RuleItem) => {
  const hostResource = ruleItem.rule.event_host_resource;
  return getResourceSumNum(hostResource);
};

/** 获取主办方成员数 */
export const getOrgMemberNum = (ruleItem: RuleItem) =>
  Number(ruleItem.rule.host_org_member_num || '');

// 是否开启付费门票权限
export const hasPaidTicket = (ruleItem: RuleItem) => ruleItem.rule.paid_ticket_switch === 1;

// 是否可配置
export const canConfig = (ruleItem: RuleItem) => ruleItem.rule_type === RuleType.ultimate;

/** 获取会场资源 */
export const getVenueResourceList = (ruleItem: RuleItem) => {
  const venueResource = ruleItem.rule.venue_resource;
  if (!venueResource || venueResource.length === 0) return [];
  // 直播大厅排在前面
  const sortArr = venueResource.sort((a, b) => Number(a.venue_type) - Number(b.venue_type));
  return sortArr?.map((venueItem) => {
    const { venue_type: venueType, size, audience_num: audienceNum } = venueItem;
    return {
      title: venueType === 1 ? '直播大厅' : '讨论室',
      key: venueType === 1 ? `stage-${audienceNum}` : `session-${audienceNum}`,
      config: canConfig(ruleItem), // 旗舰版可配置
      num: Number(size),
      audienceNum,
      pageKey: 'venueData',
    };
  });
};

/** 获取付费版本list以及对应的能力信息 */
export const getVersionList = (ruleList?: VipRules) => {
  if (!ruleList || ruleList.length === 0) return [];
  const filterList = ruleList.filter((item) => item.rule_type !== RuleType.free);
  return filterList.map((listItem) => {
    const { name, rule_type: ruleType } = listItem;
    const venueResource = getVenueResourceList(listItem) || [];
    const data: CardData = {
      name,
      price: '0',
      realPrice: '0', // 不用这个价格信息，使用询价的价格
      key: ruleType as RuleType,
      features: [
        {
          title: '嘉宾数量',
          key: 'guestNum',
          num: getGuestResourceNum(listItem),
          config: canConfig(listItem), // 旗舰版可配置
        },
        {
          title: '主持人数量',
          key: 'hostNum',
          num: getHostResourceNum(listItem),
          config: canConfig(listItem), // 旗舰版可配置
        },
        {
          title: '付费门票',
          key: 'ticket',
          config: hasPaidTicket(listItem),
        },
        {
          title: '主办方成员',
          key: 'member',
          num: getOrgMemberNum(listItem),
        },
        ...venueResource,
      ],
    };
    return data;
  });
};
